import React from "react";
import Select from "react-select";
import { useState, useEffect } from "react";
import { getCustomStyles } from "../../utils/reactSelectStyling";

function React_select(props) {
  const [selectedOption, setSelectedOption] = useState("default");
  
  // Safety check to ensure data is always an array
  const safeData = Array.isArray(props.data) ? props.data : [];
  
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  useEffect(() => {
    let match;
    match = safeData.filter((f) => f[props.optionId] == props.selectOnLoadOption);
    
    if(match.length > 0 && (selectedOption === "default")){ 
      let output = {value: match[0][props.optionId], label: match[0][props.optionValue]}
      setSelectedOption(output);
    }
  }, [props.selectOnLoadOption, safeData]);

  useEffect(() => {
    if(typeof props.overRideSelectedValue !== 'undefined' && props.overRideSelectedValue !== null){ 
      let output = {value: props.overRideSelectedValue.id, label: props.overRideSelectedValue.label}
      setSelectedOption(output);
    }
  }, [props.overRideSelectedValue]);

  const whiteSelectStyle = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      backgroundColor: "white",
      border: '1px solid var(--black)',
      minHeight: "32px",
      minWidth: "150px",
      width: 'fit-content',
      height: "32px",
      padding: "0px 2px 4px",
      opacity: state.isDisabled ? 0.7: 1,
      cursor: state.isDisabled ? 'auto': 'pointer',
      "&:hover": {},
    }),
    menu: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "12px",
      border: "1px solid #d9d9d9;",
      boxShadow: "0px 1px 1px #d9d9d9;",
      borderRadius: "6px",
      padding: "0px 1px 0px 0px",
      fontWeight: 'normal',
      minWidth: "150px",
      width: 'fit-content',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "calc(27px * 10)",
      borderRadius: "6px",
      overflowY: "auto",
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "6px 0px 6px 8px",
      backgroundColor: state.isSelected
        ? "#3367BC"
        : state.isFocused
        ? "white"
        : "white",
      color: state.isSelected ? "white" : "#252525ff",
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#3367BC"
          : "rgba(206,232,255, 0.3)",
        color: state.isSelected ? "white" : "#252525ff",
        cursor: "pointer",
        padding: "6px 0px 6px 8px",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#222",
      fontSize: "14px",
      fontWeight: 'normal',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#222",
      fontSize: "14px",
      fontWeight: 'normal',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "3px 10px 2px 4px",
      height: "28px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "30px",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: 'transparent',
      marginLeft: 0,
      marginRight: 0,
      width: 0,
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
      color: "#222",
    }),
  };

  const inputFormStyling = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      backgroundColor: "white",
      border: 'unset',
      borderBottom: '1px solid var(--black)',
      borderRadius: '0px',
      minHeight: "32px",
      height: "32px",
      padding: "0px 2px 4px",
      opacity: state.isDisabled ? 0.7: 1,
      cursor: state.isDisabled ? 'auto': 'pointer',
      boxShadow: state.isFocused ? `0 0 0 1px transparent` : provided.boxShadow,
      "&:hover": {},
    }),
    menu: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "12px",
      border: "1px solid #d9d9d9;",
      boxShadow: "0px 1px 1px #d9d9d9;",
      borderRadius: "3px",
      padding: "0px 1px 0px 0px",
      fontWeight: 'normal',
      marginTop: '4px',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "calc(27px * 10)",
      borderRadius: "3px",
      overflowY: "auto",
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "6px 0px 6px 8px",
      backgroundColor: state.isSelected
        ? "#3367BC"
        : state.isFocused
        ? "white"
        : "white",
      color: state.isSelected ? "white" : "#252525ff",
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#3367BC"
          : "rgba(206,232,255, 0.3)",
        color: state.isSelected ? "white" : "#252525ff",
        cursor: "pointer",
        padding: "6px 0px 6px 8px",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#222",
      fontSize: "14px",
      fontWeight: 'normal',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#222",
      fontSize: "14px",
      fontWeight: 'normal',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "6px 0px 2px 2px",
      height: "28px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "30px",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: 'transparent',
      marginLeft: 0,
      marginRight: 0,
      width: 0,
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
      color: "#222",
    }),
  };

  const inputFormStyling_v2 = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      backgroundColor: "white",
      border: 'unset',
      borderBottom: '1px solid var(--black)',
      borderRadius: '0px',
      minHeight: "32px",
      height: "32px",
      padding: "0px 2px 4px",
      opacity: state.isDisabled ? 0.7: 1,
      cursor: state.isDisabled ? 'auto': 'pointer',
      boxShadow: state.isFocused ? `0 0 0 1px transparent` : provided.boxShadow,
      "&:hover": {},
    }),
    menu: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "12px",
      border: "1px solid #d9d9d9;",
      boxShadow: "0px 1px 1px #d9d9d9;",
      borderRadius: "3px",
      padding: "0px 1px 0px 0px",
      fontWeight: 'normal',
      marginTop: '4px',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "calc(27px * 10)",
      borderRadius: "3px",
      overflowY: "auto",
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "6px 0px 6px 8px",
      backgroundColor: state.isSelected
        ? "#3367BC"
        : state.isFocused
        ? "white"
        : "white",
      color: state.isSelected ? "white" : "#252525ff",
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#3367BC"
          : "rgba(206,232,255, 0.3)",
        color: state.isSelected ? "white" : "#252525ff",
        cursor: "pointer",
        padding: "6px 0px 6px 8px",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#222",
      fontSize: "14px",
      fontWeight: 'normal',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#222",
      fontSize: "14px",
      fontWeight: 'normal',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "2px 0px 2px 2px",
      height: "28px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "30px",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: 'transparent',
      marginLeft: 0,
      marginRight: 0,
      width: 0,
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
      color: "#222",
    }),
  };

  const inputFormStyling_icon = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      backgroundColor: "white",
      border: 'unset',
      borderBottom: '1px solid var(--black)',
      borderRadius: '0px',
      minHeight: "37.5px",
      height: "37.5px",
      padding: "0px 2px 5px 24px",
      opacity: state.isDisabled ? 0.7: 1,
      cursor: state.isDisabled ? 'auto': 'pointer',
      boxShadow: state.isFocused ? `0 0 0 1px transparent` : provided.boxShadow,
      "&:hover": {},
    }),
    menu: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "12px",
      border: "1px solid #d9d9d9;",
      boxShadow: "0px 1px 1px #d9d9d9;",
      borderRadius: "3px",
      padding: "0px 1px 0px 0px",
      fontWeight: 'normal',
      marginTop: '4px',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "calc(27px * 10)",
      borderRadius: "3px",
      overflowY: "auto",
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "6px 0px 6px 8px",
      backgroundColor: state.isSelected
        ? "#3367BC"
        : state.isFocused
        ? "white"
        : "white",
      color: state.isSelected ? "white" : "#252525ff",
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#3367BC"
          : "rgba(206,232,255, 0.3)",
        color: state.isSelected ? "white" : "#252525ff",
        cursor: "pointer",
        padding: "6px 0px 6px 8px",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#222",
      fontSize: "14px",
      fontWeight: 'normal',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#222",
      fontSize: "14px",
      fontWeight: 'normal',
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "28px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "30px",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: 'transparent',
      marginLeft: 0,
      marginRight: 0,
      width: 0,
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px 0px 0px",
      color: "#222",
    }),
  };

  const popupFormStyling = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      backgroundColor: "#f5f5f5",
      minHeight: "32px",
      height: "32px",
      padding: "0px 2px 4px",
      opacity: state.isDisabled ? 0.7: 1,
      cursor: state.isDisabled ? 'auto': 'pointer',
      margin: "4px 0px 0px",
      "&:hover": {},
    }),
    menu: (provided) => ({
      ...provided,
      color: "#f5f5f5",
      fontSize: "11px",
      border: "1px solid #d9d9d9;",
      boxShadow: "0px 1px 1px #d9d9d9;",
      borderRadius: "3px",
      padding: "0px 1px 0px 0px",
      fontWeight: 'normal',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "calc(27px * 10)",
      borderRadius: "3px",
      overflowY: "auto",
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "6px 0px 6px 8px",
      backgroundColor: state.isSelected
        ? "#3367BC"
        : state.isFocused
        ? "#fff"
        : "#fff",
      color: state.isSelected ? "#fff" : "#252525ff",
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#3367BC"
          : "rgba(206,232,255, 0.3)",
        color: state.isSelected ? "#fff" : "#252525ff",
        cursor: "pointer",
        padding: "6px 0px 6px 8px",
        fontSize: "11px",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#222",
      fontSize: "12px",
      fontWeight: 'normal',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#222",
      fontSize: "12px",
      fontWeight: 'normal',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "3px 10px 2px 4px",
      height: "28px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "30px",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: 'transparent',
      marginLeft: 0,
      marginRight: 0,
      width: 0,
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
      color: "#222",
    }),
  };

  const whiteSelectStyle_inRow = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "12px",
      backgroundColor: "white",
      border: '1px solid var(--black)',
      minHeight: "24px",
      height: "24px",
      maxHeight: "24px",
      minWidth:'150px',
      maxWidth:'150px',
      padding: "0px 2px 4px",
      opacity: state.isDisabled ? 0.7: 1,
      cursor: state.isDisabled ? 'auto': 'pointer',
      "&:hover": {},
    }),
    menu: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "12px",
      border: "1px solid #d9d9d9;",
      boxShadow: "0px 1px 1px #d9d9d9;",
      borderRadius: "6px",
      padding: "0px 1px 0px 0px",
      fontWeight: 'normal',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "calc(27px * 10)",
      borderRadius: "6px",
      overflowY: "auto",
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "6px 0px 6px 8px",
      backgroundColor: state.isSelected
        ? "#3367BC"
        : state.isFocused
        ? "white"
        : "white",
      color: state.isSelected ? "white" : "#252525ff",
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#3367BC"
          : "rgba(206,232,255, 0.3)",
        color: state.isSelected ? "white" : "#252525ff",
        cursor: "pointer",
        padding: "6px 0px 6px 8px",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#222",
      fontSize: "12px",
      fontWeight: 'normal',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#222",
      fontSize: "12px",
      fontWeight: 'normal',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "1px 10px 5px 4px",
      height: "28px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "22px",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: 'transparent',
      marginLeft: 0,
      marginRight: 0,
      width: 0,
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
      color: "#222",
    }),
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      backgroundColor: "#3367BC",
      minHeight: "32px",
      height: "32px",
      padding: "0px 2px 4px",
      minWidth: "120px",
      width:"fit-content",
      opacity: state.isDisabled ? 0.7: 1,
      cursor: state.isDisabled ? 'auto': 'pointer',
      "&:hover": {},
    }),
    menu: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "12px",
      border: "1px solid #d9d9d9;",
      boxShadow: "0px 1px 1px #d9d9d9;",
      borderRadius: "6px",
      padding: "0px 1px 0px 0px",
      minWidth: "120px",
      width:"fit-content",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "calc(27px * 10)",
      borderRadius: "6px",
      overflowY: "auto",
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "6px 0px 6px 8px",
      backgroundColor: state.isSelected
        ? "#3367BC"
        : state.isFocused
        ? "white"
        : "white",
      color: state.isSelected ? "white" : "#252525ff",
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#3367BC"
          : "rgba(206,232,255, 0.3)",
        color: state.isSelected ? "white" : "#252525ff",
        cursor: "pointer",
        padding: "6px 0px 6px 8px",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "14px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "14px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "3px 10px 2px 4px",
      height: "28px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "30px",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: 'transparent',
      marginLeft: 0,
      marginRight: 0,
      width: 0,
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
      color: "#fdfdfdff",
    }),
  };

  const mediumStyle = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      backgroundColor: "#3367BC",
      minHeight: "32px",
      height: "32px",
      padding: "0px 2px 4px",
      minWidth: "180px",
      width:"fit-content",
      opacity: state.isDisabled ? 0.7: 1,
      cursor: state.isDisabled ? 'auto': 'pointer',
      "&:hover": {},
    }),
    menu: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "12px",
      border: "1px solid #d9d9d9;",
      boxShadow: "0px 1px 1px #d9d9d9;",
      borderRadius: "6px",
      padding: "0px 1px 0px 0px",
      minWidth: "180px",
      width:"fit-content",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "calc(27px * 10)",
      borderRadius: "6px",
      overflowY: "auto",
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "6px 0px 6px 8px",
      backgroundColor: state.isSelected
        ? "#3367BC"
        : state.isFocused
        ? "white"
        : "white",
      color: state.isSelected ? "white" : "#252525ff",
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#3367BC"
          : "rgba(206,232,255, 0.3)",
        color: state.isSelected ? "white" : "#252525ff",
        cursor: "pointer",
        padding: "6px 0px 6px 8px",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "14px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "14px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "3px 10px 2px 4px",
      height: "28px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "30px",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: 'transparent',
      marginLeft: 0,
      marginRight: 0,
      width: 0,
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
      color: "#fdfdfdff",
    }),
  };

  const smallStyle = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      backgroundColor: "#3367BC",
      minHeight: "32px",
      height: "32px",
      padding: "0px 2px 4px",
      minWidth: "150px",
      width:"fit-content",
      opacity: state.isDisabled ? 0.7: 1,
      cursor: state.isDisabled ? 'auto': 'pointer',
      "&:hover": {},
    }),
    menu: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "12px",
      border: "1px solid #d9d9d9;",
      boxShadow: "0px 1px 1px #d9d9d9;",
      borderRadius: "6px",
      padding: "0px 1px 0px 0px",
      minWidth: "150px",
      width:"fit-content",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "calc(27px * 10)",
      borderRadius: "6px",
      overflowY: "auto",
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "6px 0px 6px 8px",
      backgroundColor: state.isSelected
        ? "#3367BC"
        : state.isFocused
        ? "white"
        : "white",
      color: state.isSelected ? "white" : "#252525ff",
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#3367BC"
          : "rgba(206,232,255, 0.3)",
        color: state.isSelected ? "white" : "#252525ff",
        cursor: "pointer",
        padding: "6px 0px 6px 8px",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "14px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "14px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "3px 10px 2px 4px",
      height: "28px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "30px",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: 'transparent',
      marginLeft: 0,
      marginRight: 0,
      width: 0,
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
      color: "#fdfdfdff",
    }),
  };

  const chaseSelect = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "11px",
      backgroundColor: "#f5f5f5",
      minHeight: "34px",
      height: "34px",
      padding: "0px 2px 4px",
      borderRadius: "0px",
      opacity: state.isDisabled ? 0.7: 1,
      cursor: state.isDisabled ? 'auto': 'pointer',
      borderColor: state.isFocused ? '#d9d9d9' : '#d9d9d9',
      boxShadow: state.isFocused ? 'none' : 'none',
      "&:hover": {},
    }),
    menu: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "11px",
      border: "1px solid #d9d9d9;",
      boxShadow: "0px 1px 1px #d9d9d9;",
      borderRadius: "3px",
      padding: "0px 1px 0px 0px",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "calc(27px * 5)",
      borderRadius: "3px",
      overflowY: "auto",
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "6px 0px 6px 8px",
      backgroundColor: state.isSelected
        ? "#3367BC"
        : state.isFocused
        ? "white"
        : "white",
      color: state.isSelected ? "white" : "#252525ff",
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#3367BC"
          : "rgba(206,232,255, 0.3)",
        color: state.isSelected ? "white" : "#252525ff",
        cursor: "pointer",
        padding: "6px 0px 6px 8px",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
      fontSize: "11px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "black",
      fontSize: "11px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "3px 10px 2px 4px",
      height: "28px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "30px",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: 'transparent',
      marginLeft: 0,
      marginRight: 0,
      width: 0,
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
      color: "black",
    }),
  };

  const externalStyling = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      backgroundColor: "#3367BC",
      minHeight: "32px",
      height: "32px",
      padding: "0px 2px 4px",
      minWidth: "120px",
      width:"fit-content",
      opacity: state.isDisabled ? 0.7: 1,
      cursor: state.isDisabled ? 'auto': 'pointer',
      "&:hover": {},
    }),
    menu: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "12px",
      border: "1px solid #d9d9d9;",
      boxShadow: "0px 1px 1px #d9d9d9;",
      borderRadius: "6px",
      padding: "0px 1px 0px 0px",
      minWidth: "120px",
      width:"fit-content",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "calc(27px * 10)",
      borderRadius: "6px",
      overflowY: "auto",
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "6px 0px 6px 8px",
      backgroundColor: state.isSelected
        ? "#3367BC"
        : state.isFocused
        ? "white"
        : "white",
      color: state.isSelected ? "white" : "#252525ff",
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#3367BC"
          : "rgba(206,232,255, 0.3)",
        color: state.isSelected ? "white" : "#252525ff",
        cursor: "pointer",
        padding: "6px 0px 6px 8px",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "14px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "14px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "3px 10px 2px 4px",
      height: "28px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "30px",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: 'transparent',
      marginLeft: 0,
      marginRight: 0,
      width: 0,
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
      color: "#fdfdfdff",
    }),
  };

  const inRowStyling = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "12px",
      backgroundColor: "#3367BC",
      minHeight: "24px",
      height: "24px",
      maxHeight: "24px",
      minWidth: "fit-content",
      margin: "0px 6px",
      padding: "0px 2px 4px",
      opacity: state.isDisabled ? 0.7: 1,
      cursor: state.isDisabled ? 'auto': 'pointer',
      "&:hover": {},
    }),
    menu: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "12px",
      border: "1px solid #d9d9d9;",
      boxShadow: "0px 1px 1px #d9d9d9;",
      borderRadius: "6px",
      padding: "0px 1px 0px 0px",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "calc(27px * 10)",
      borderRadius: "6px",
      overflowY: "auto",
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "6px 0px 6px 8px",
      backgroundColor: state.isSelected
        ? "#3367BC"
        : state.isFocused
        ? "white"
        : "white",
      color: state.isSelected ? "white" : "#252525ff",
      "&:hover": {
        backgroundColor: state.isSelected
          ? "#3367BC"
          : "rgba(206,232,255, 0.3)",
        color: state.isSelected ? "white" : "#252525ff",
        cursor: "pointer",
        padding: "6px 0px 6px 8px",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "12px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "white",
      fontSize: "12px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "0px 10px 3px 4px",
      height: "28px",
      textAlign: 'left',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "24px",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: 'transparent',
      marginLeft: 0,
      marginRight: 0,
      width: 0,
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "4px",
      color: "white",
    }),
  };

  function formatDataToOptions() {
    let output = [];
    if(props.defaultSelectable == true){
      output.push({
        value: props.defaultId,
        label: props.defaultVal,
      });
    }
    for (var i = 0; i < safeData.length; i++) {
      output.push({
        value: safeData[i][props.optionId],
        label: safeData[i][props.optionValue],
      });
    }
    return output;
  }

  const handleChange = (option) => {
    setSelectedOption(option);
    console.groupCollapsed('react select value change: '+props.inputName)
    console.log(option);
    console.table(formatDataToOptions());
    console.groupEnd();
    if(props.isMulti){
      console.log('change value passed to parent multi select handler')
      props.updateMethod(option);
    }else{
      console.log('pass to parent new option of: '+option.value);
      props.updateMethod(props.inputName, option.value);
    }
  };

  function stylingSelect(){
    console.log(props.classes);
    if(props.classes.includes('oa-row-white-select')){
      return whiteSelectStyle_inRow;
    }else if(props.classes.includes('in-table-select')){
      return inRowStyling;
    }else if(props.classes.includes('form-input-select')){
      return popupFormStyling;
    }else if(props.classes.includes('select-white')){
      return whiteSelectStyle;
    }else if(props.classes.includes('select-inputForm-underline')){
      return inputFormStyling;
    }else if(props.classes.includes('select-inputForm-v2-underline')){
      return inputFormStyling_v2;
    }else if(props.classes.includes('select-inputForm-icon-Underline')){
      return inputFormStyling_icon;
    }else if(props.classes.includes('chase-select')){
      return chaseSelect;
    }else if(props.classes.includes('medium')){
      return mediumStyle;
    }else if(props.classes.includes('small')){
      return smallStyle;
    }else if(props.isMulti){
      return "";
    }else{
      return customStyles;
    }
  }

  function handleSelectOnLoad(setOnLoad){
    console.log('react select pre select value for');
    console.log(setOnLoad);
    console.log(props.selectOnLoadOption);
    console.log(selectedOption);
    console.table(formatDataToOptions());
    console.log(formatDataToOptions())
    if(typeof setOnLoad !== "undefined"){
      return setOnLoad;
    }else{
      return selectedOption;
    }
  }

  return (
    <div className="reactSelect" title={props.title} id={props.id}>
      {typeof props.iconDetails !== "undefined" &&
        <span className="material-symbols-outlined" style={{color: props.iconDetails.colour, zIndex: 1, fontSize: props.iconDetails.fontSize}}>{props.iconDetails.icon}</span>
      }
      <Select
        styles={stylingSelect()}
        name={props.inputName} 
        options={formatDataToOptions()}
        value={selectedOption}
        onChange={handleChange}
        isDisabled={props.disabled}
        placeholder={props.defaultVal}
        isSearchable={typeof props.searchable !== "undefined" ? props.searchable : false}   
        isMulti={typeof props.isMulti !== "undefined" ? props.isMulti : false}
      />
    </div>
  );
}

export default React_select;